import { SimpleCollection } from "kreate-common/modules/business-types";

export function getMintingLimit(collection: SimpleCollection) {
  // https://kreate.art/collection/BOBYZ
  if (collection.collectionId === "64cf7f414fcd8ca38e2ef9e9") {
    return 5;
  }

  return undefined; // unlimited
}
